export type TagKind = "prose" | "container" | "atomic" | "control";

export interface TagSpec {
  kind: TagKind;
  rendered: boolean;
  label?: string;
}

export const TAG_MAP: Record<string, TagSpec> = {
  "zv:reply": { kind: "control", rendered: false },
  "zv:msg": { kind: "prose", rendered: true },
  "zv:intro": { kind: "prose", rendered: true },
  "zv:outro": { kind: "prose", rendered: true },
  "zv:summary": { kind: "prose", rendered: true },
  "zv:say": { kind: "prose", rendered: true },
  "zv:act": { kind: "container", rendered: true, label: "activity" },
  "zv:itinerary": { kind: "container", rendered: true, label: "itinerary" },
  "zv:destinations": { kind: "container", rendered: true, label: "destinations" },
  "zv:day": { kind: "container", rendered: true, label: "day" },
  "zv:place": { kind: "atomic", rendered: true, label: "place" },
  "zv:cities": { kind: "atomic", rendered: false },
  "zv:trip-prefs": { kind: "atomic", rendered: false },
  "zv:leg": { kind: "atomic", rendered: false },
  "zv:stay": { kind: "atomic", rendered: false },
};

export function getTagSpec(tag: string): TagSpec | undefined {
  return TAG_MAP[tag];
}

export const KNOWN_ITINERARY_TAGS = new Set<string>([
  "zv:reply",
  "zv:msg",
  "zv:intro",
  "zv:trip-prefs",
  "zv:itinerary",
  "zv:cities",
  "zv:summary",
  "zv:day",
  "zv:say",
  "zv:act",
  "zv:leg",
  "zv:stay",
  "zv:outro",
]);

export const KNOWN_ACT_TYPE_PREFIXES = new Set<string>([
  "transportation",
  "accommodation",
  "restaurant",
  "place",
  "event",
]);
